import axios from "axios";
import { Berceau } from "../../Models/Marketing/BerceauModel"
import { URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";
import { EnseigneService } from "../Magasin/EnseigneService";
import { DataBerceau } from "../../Models/Admin/AdminModels";

export function BerceauService(){
    return{
        async getBerceaux(token:string){
            let berceaux:Berceau[]=[];
            try {
                const reponse = await axios.get(`${URLAPI+'berceaux'}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type":"application/ld+json"
                    },
                });
                const data = reponse.data['hydra:member'];
                for(const element of data){
                    berceaux.push({
                        id:element['id'],
                        "@id":element['@id'],
                        description:element['description'],
                        type:element['type'],
                        enseigne:{id:0, fichiers:[], nom:'',"@id":element['enseigne']}
                    })
                }
                const enseignes = await EnseigneService().getEnseignes(token);
                for(let indexBerceaux=0;indexBerceaux<berceaux.length;indexBerceaux++){
                    let initialBerceau = berceaux[indexBerceaux];
                    const enseigneResult = enseignes.find(enseigne=>enseigne["@id"]===initialBerceau.enseigne?.["@id"]);
                    if(enseigneResult){
                        initialBerceau.enseigne = enseigneResult;
                        berceaux.map(berceau=>{
                            if(berceau.id===initialBerceau.id)return initialBerceau;
                            return berceau;
                        })
                    }
                }
            } catch (error) {
                errorService().handleError('Erreur obtention berceaux',error);         
                return [];       
            }
            return berceaux
        },

        async deleteBerceau(idBerceau:number, token:string){
            const responseMagasin = await axios.delete(
                `${URLAPI}berceau/${idBerceau}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            return responseMagasin.status;
        },

        async ajoutBerceauAdmin(data:DataBerceau, token:string){
            try {
                const postObjectBerceau = {
                    "type": data.introduction ? 'introduction' : 'signature',
                    "description": data.description,
                    "enseigne": data.idEnseigne
                }

                const responsePOSTMarketing = await axios.post(
                    `${URLAPI+'berceau'}`,
                    postObjectBerceau,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                return responsePOSTMarketing.status
            } catch (error) {
                errorService().handleError('Erreur ajout annonce', error);
                return 400;
            }
        },

        async modificationBerceauAdmin(data:DataBerceau, token:string){
            try {
                const patchObjectBerceau = {
                    "type": data.introduction ? 'introduction' : 'signature',
                    "description": data.description,
                    "enseigne": data.idEnseigne
                }

                const responsePATCHMarketing = await axios.patch(
                    `${URLAPI+'berceau/'+data.id}`,
                    patchObjectBerceau,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        },
                    }
                );

                return responsePATCHMarketing.status
            } catch (error) {
                errorService().handleError('Erreur ajout annonce', error);
                return 400;
            }
        },
    }
}